import { ApiResponse } from "@/utils/ApiResponse";
import apiClient from "@/clients/apiClient";
import { CategoriaSelectInterface } from "../../interfaces/categoriaInterfaces/CategoriaProductoSelect.interface";

export async function FindAllCategoriaSelectAction(): Promise<
  ApiResponse<CategoriaSelectInterface>
> {
  const { data } = await apiClient.get<CategoriaSelectInterface>(
    "/gpCategoriasProducto/select"
  );
  return {
    status: 200,
    data,
    message: "Categoria de producto obtenidas correctamente",
  };
}
